(() => {
  const TEST_KEY = 'rp_home_variant_v2';
  const VALID = new Set(['dark']);
  const DEFAULT_VARIANT = 'dark';
  const params = new URLSearchParams(window.location.search);
  const forced = params.get('rp_variant') || params.get('variant') || params.get('ab');

  function readCookie(name) {
    return document.cookie.split('; ').find((row) => row.startsWith(`${name}=`))?.split('=')[1];
  }

  function writeCookie(name, value) {
    const maxAge = 60 * 60 * 24 * 45;
    document.cookie = `${name}=${value}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
  }

  function chooseVariant() {
    // Dark is now the production homepage. Do not randomly expose visitors
    // to the unfinished light direction, and ignore stale light QA URLs.
    if (VALID.has(forced)) return forced;
    return DEFAULT_VARIANT;
  }

  const variant = chooseVariant();
  try { localStorage.setItem(TEST_KEY, variant); } catch (e) {}
  writeCookie(TEST_KEY, variant);
  document.documentElement.setAttribute('data-rp-home-variant', variant);
  document.documentElement.classList.add(`rp-ab-${variant}`);

  function publishExposure() {
    const payload = {
      experiment: 'rite_homepage_visual_direction_v1',
      variant,
      path: window.location.pathname,
      source: forced ? 'url_override' : 'dark_default',
      ts: new Date().toISOString()
    };
    window.RiteHomeAB = { variant, payload };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'rite_homepage_ab_exposure', ...payload });
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish('rite_homepage_ab_exposure', payload);
    }
    document.dispatchEvent(new CustomEvent('rite:homepage-ab-exposure', { detail: payload }));
  }

  function tagLinks() {
    document.querySelectorAll('a[href^="/"], a[href^="' + window.location.origin + '"]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        if (url.origin === window.location.origin && !url.searchParams.has('rp_variant')) {
          url.searchParams.set('rp_variant', variant);
          link.href = url.pathname + url.search + url.hash;
        }
      } catch (e) {}
    });
  }

  function addDebugBadge() {
    if (!params.has('ab_debug')) return;
    const badge = document.createElement('div');
    badge.className = 'rp-ab-debug-badge';
    badge.innerHTML = `Rite homepage: <strong>${variant}</strong> · <a href="/?rp_variant=dark&ab_debug=1">dark production</a>`;
    document.body.appendChild(badge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { tagLinks(); addDebugBadge(); publishExposure(); });
  } else {
    tagLinks(); addDebugBadge(); publishExposure();
  }
})();
